import Hyperlink from './components/Hyperlink';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'hyperlink',
  pluginComponent: Hyperlink,
});
